/*
 * @Author: your name
 * @Date: 2021-08-12 09:24:24
 * @LastEditTime: 2023-11-06 10:34:44
 * @LastEditors: LAPTOP-JM4BAR46
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\components\index.js
 */
import BjForm from './BjForm';
import BjTable from './BjTable/BjTable';
import Pagination from './Pagination';
import RightToolbar from './RightToolbar';
import BjPage from './BjPage/index';
import BjGoodsTypeTreeSelect from './BjGoodsTypeTreeSelect/index';
import BjCompanyTreeSelect from './BjCompanyTreeSelect/index';
import BjSelectBrand from './BjSelectBrand/index';
import BjSelectWarehouse from './BjSelectWarehouse/index';
import BjSelectMaterial from './BjSelectMaterial/index';
import BjSelectTenant from './BjSelectTenant/index';
import BjKeyImage from './BjKeyImage/index';
import BjKeyVideo from './BjKeyVideo/index';
import BjViewUrl from './BjViewUrl/index';
import BjLogTable from './BjLogTable';
import BjLogTableDialog from './BjLogTableDialog';
import BjSelectStore from './BjSelectStore';
import BjSelectLogisticCompany from './BjSelectLogisticCompany';
import BjSelectLogisticBusiness from './BjSelectLogisticBusiness';
import BjSelectStoreOnline from './BjSelectStoreOnline';
import BjFormItemMobile from './BjFormItemMobile';
import BjFormItemCode from './BjFormItemCode';
import BjFormItemEmail from './BjFormItemEmail';
import BjSelectStorage from './BjSelectStorage';
import BjSelectChannelStore from './BjSelectChannelStore';
import BjPreviewList from './BjPreviewList';
import BjStatusTabs from './BjStatusTabs';
import BjSelectStorePhysical from './BjSelectStorePhysical';
import BjSelectUser from './BjSelectUser';
import BjSelectImportTemplate from './BjSelectImportTemplate';
import BjSelectLovHeader from './BjSelectLovHeader';
import BjDecrypt from './BjDecrypt';
import BjAlert from './BjAlert';
import BjRegionCascader from './BjRegionCascader';
import BjSelectSupplier from './BjSelectSupplier';
import BjExcelImportDialog from './BjExcelImportDialog';
import BjLogButton from './BjLogButton';
import BjMyRoles from './BjMyRoles';
import BjSelectSqlLov from './BjSelectSqlLov';
import BjSelectInstancesService from './BjSelectInstancesService';
import BjSelectCustomer from './BjSelectCustomer';
import BjSteps from './BjSteps';
import BjWangEditor from './BjWangEditor';
import BjFrontendExport from './BjFrontendExport';

const components = [
  BjForm,
  BjTable,
  Pagination,
  RightToolbar,
  BjPage,
  BjGoodsTypeTreeSelect,
  BjCompanyTreeSelect,
  BjSelectBrand,
  BjSelectWarehouse,
  BjSelectMaterial,
  BjSelectTenant,
  BjKeyImage,
  BjKeyVideo,
  BjViewUrl,
  BjLogTable,
  BjLogTableDialog,
  BjSelectStore,
  BjSelectLogisticCompany,
  BjSelectLogisticBusiness,
  BjSelectStoreOnline,
  BjFormItemMobile,
  BjFormItemCode,
  BjFormItemEmail,
  BjSelectStorage,
  BjSelectChannelStore,
  BjPreviewList,
  BjStatusTabs,
  BjSelectStorePhysical,
  BjSelectUser,
  BjSelectImportTemplate,
  BjSelectLovHeader,
  BjDecrypt,
  BjAlert,
  BjRegionCascader,
  BjSelectSupplier,
  BjExcelImportDialog,
  BjLogButton,
  BjMyRoles,
  BjSelectSqlLov,
  BjSelectInstancesService,
  BjSelectCustomer,
  BjSteps,
  BjWangEditor,
  BjFrontendExport,
];

const install = function(Vue, opts = {}) {
  components.forEach(component => {
    if (component.name) {
      Vue.component(component.name, component);
    } else {
      try {
        console.warn(`组件 ${component.__file.split('/')[2]} 未命名，注册失败`, component);
      } catch (error) {
        console.warn('组件未命名，注册失败', component, error);
      }
    }
  });
};
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}
export default {
  install,
};
